export default __webpack_public_path__ + "ad17f6b1442350bd72dcd84a30626fc8.jpg";